import { InitializeAddDepartmentsRequestSchema, InitializeAddDepartmentsResponseSchema } from './initialize-add-departments.schema';
/**
 * Add Departments Bulk Endpoint Contract
 * Bulk create departments in the organizational hierarchy
 * Restricted to authorized users only
 */ export const InitializeAddDepartmentsContract = {
    method: 'POST',
    path: '/api/v2/initialize/departments',
    description: 'Bulk create departments with hierarchical relationships',
    requestSchema: InitializeAddDepartmentsRequestSchema,
    responseSchema: InitializeAddDepartmentsResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-add-departments.contract.js.map